import { useCallback, useLayoutEffect, useState } from 'react';

// Tracks an element's content width via ResizeObserver; 0 until the element mounts.
export function useElementWidth<T extends HTMLElement>(): {
    ref: (el: T | null) => void;
    width: number;
} {
    const [element, setElement] = useState<T | null>(null);
    const [width, setWidth] = useState(0);
    const ref = useCallback((el: T | null) => setElement(el), []);

    useLayoutEffect(() => {
        if (!element) return undefined;
        setWidth(element.getBoundingClientRect().width);
        const observer = new ResizeObserver((entries) => {
            const entry = entries[0];
            if (entry) setWidth(entry.contentRect.width);
        });
        observer.observe(element);
        return () => observer.disconnect();
    }, [element]);

    return { ref, width };
}
